import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.timers.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { constructRestaurantDetailsUrl, formatPhoneNumber, handle, PlatformType } from "@dp/common";
import DPServices from "@dp/services";
import i18next from "i18next";
import { computed, makeObservable, observable, reaction, runInAction } from "mobx";
import moment from "moment-timezone";
import Base from "./Base";
import Errors, { ERROR_STRINGS } from "./Errors";
import { JoinWaitlistModel } from "./models";
var JoinWaitlist = (_class = /*#__PURE__*/function (_Base) {
  _inherits(JoinWaitlist, _Base);

  var _super = _createSuper(JoinWaitlist); // @observable private _restuarantDetails: RestaurantTypes.IDPRestaurantDetail =
  //   null;


  function JoinWaitlist(rootStore) {
    var _this$rootStore, _this$rootStore2, _this$rootStore2$user;

    var _this;

    var fromLocationSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, JoinWaitlist);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "joinWaitlistModel", null);

    _defineProperty(_assertThisInitialized(_this), "fromLocationSearch", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "_sessionDetails", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_appAttributes", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_hideWaitListInfoOnConfPage", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_guestOnWaitlist", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isWaitlistError", _descriptor5, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "analyticsModel", void 0);

    _this.rootStore = rootStore;
    _this.joinWaitlistModel = new JoinWaitlistModel((_this$rootStore = _this.rootStore) === null || _this$rootStore === void 0 ? void 0 : _this$rootStore.platformUtil);
    _this.analyticsModel = (_this$rootStore2 = _this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$user = _this$rootStore2.user) === null || _this$rootStore2$user === void 0 ? void 0 : _this$rootStore2$user.analyticsModel;
    _this.fromLocationSearch = fromLocationSearch;
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(JoinWaitlist, [{
    key: "_processSessionDetails",
    value: function _processSessionDetails(session) {
      var _this2 = this;

      runInAction(function () {
        _this2._sessionDetails = session;
      });
    }
  }, {
    key: "_processAppAttributes",
    value: function () {
      var _processAppAttributes2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(appAttributes) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                runInAction(function () {
                  _this3._appAttributes = appAttributes;
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function _processAppAttributes(_x) {
        return _processAppAttributes2.apply(this, arguments);
      }

      return _processAppAttributes;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$rootStore3, _this$rootStore3$user, _this$rootStore4, _this$rootStore4$comm, _this$joinWaitlistMod, _this$rootStore5, _this$rootStore5$comm;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this._processSessionDetails((_this$rootStore3 = this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : (_this$rootStore3$user = _this$rootStore3.user) === null || _this$rootStore3$user === void 0 ? void 0 : _this$rootStore3$user.sessionDetails);

                this._processAppAttributes((_this$rootStore4 = this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$comm = _this$rootStore4.common) === null || _this$rootStore4$comm === void 0 ? void 0 : _this$rootStore4$comm.appAttributes);

                (_this$joinWaitlistMod = this.joinWaitlistModel) === null || _this$joinWaitlistMod === void 0 ? void 0 : _this$joinWaitlistMod.setAppAttributes((_this$rootStore5 = this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$comm = _this$rootStore5.common) === null || _this$rootStore5$comm === void 0 ? void 0 : _this$rootStore5$comm.appAttributes);
                _context2.next = 5;
                return handle(this.rootStore.platformUtil.hydrateUsingLocalStorage("USER_JOINWAITLIST_DETAILS", this.joinWaitlistModel));

              case 5:
                if (!(this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 8;
                return Promise.all([this.getWaitlist()]);

              case 8:
                _context2.next = 12;
                break;

              case 10:
                _context2.next = 12;
                return this.loadAndSetWaitlistId();

              case 12:
                return _context2.abrupt("return");

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function refresh() {
      return Promise.resolve();
    }
  }, {
    key: "reset",
    value: function reset() {
      return Promise.resolve();
    }
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      var _this4 = this;

      reaction(function () {
        var _this4$rootStore, _this4$rootStore$user;

        return {
          detail: (_this4$rootStore = _this4.rootStore) === null || _this4$rootStore === void 0 ? void 0 : (_this4$rootStore$user = _this4$rootStore.user) === null || _this4$rootStore$user === void 0 ? void 0 : _this4$rootStore$user.sessionDetails
        };
      }, /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this4._processSessionDetails(data === null || data === void 0 ? void 0 : data.detail);

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }()); // reaction(
      //   () => {
      //     return {
      //       restaurantNum: this.joinWaitlistModel.currentWaitlistRestNum,
      //     };
      //   },
      //   async (data) => {
      //     this.getWaitTime(data?.restaurantNum);
      //   },
      // );

      reaction(function () {
        var _this4$rootStore2, _this4$rootStore2$com;

        return {
          detail: (_this4$rootStore2 = _this4.rootStore) === null || _this4$rootStore2 === void 0 ? void 0 : (_this4$rootStore2$com = _this4$rootStore2.common) === null || _this4$rootStore2$com === void 0 ? void 0 : _this4$rootStore2$com.appAttributes
        };
      }, /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
          var _this4$joinWaitlistMo;

          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _this4._processAppAttributes(data === null || data === void 0 ? void 0 : data.detail);

                  (_this4$joinWaitlistMo = _this4.joinWaitlistModel) === null || _this4$joinWaitlistMo === void 0 ? void 0 : _this4$joinWaitlistMo.setAppAttributes(data === null || data === void 0 ? void 0 : data.detail);

                case 2:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }());
      reaction(function () {
        var _this4$joinWaitlistMo2, _this4$joinWaitlistMo3;

        return {
          restaurantNumber: (_this4$joinWaitlistMo2 = _this4.joinWaitlistModel) === null || _this4$joinWaitlistMo2 === void 0 ? void 0 : (_this4$joinWaitlistMo3 = _this4$joinWaitlistMo2.restaurantDetail) === null || _this4$joinWaitlistMo3 === void 0 ? void 0 : _this4$joinWaitlistMo3.restaurantNumber
        };
      }, function (data) {
        var _this4$joinWaitlistMo4, _data$restaurantNumbe;

        if (data !== null && data !== void 0 && data.restaurantNumber && !((_this4$joinWaitlistMo4 = _this4.joinWaitlistModel) !== null && _this4$joinWaitlistMo4 !== void 0 && _this4$joinWaitlistMo4.pdfMenuUrl)) _this4._getPdfMenuUrl(data === null || data === void 0 ? void 0 : (_data$restaurantNumbe = data.restaurantNumber) === null || _data$restaurantNumbe === void 0 ? void 0 : _data$restaurantNumbe.toString());
      });
    }
  }, {
    key: "loadAndGetWaitlistId",
    value: function () {
      var _loadAndGetWaitlistId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var waitlistId;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                waitlistId = this.joinWaitlistModel.waitListId;

                if (waitlistId) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 4;
                return this.rootStore.platformUtil.getFromLocalStorage("WAITLIST_ID");

              case 4:
                waitlistId = _context5.sent;

              case 5:
                return _context5.abrupt("return", waitlistId);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function loadAndGetWaitlistId() {
        return _loadAndGetWaitlistId.apply(this, arguments);
      }

      return loadAndGetWaitlistId;
    }()
  }, {
    key: "loadWineWhileYouWaitInfo",
    value: function () {
      var _loadWineWhileYouWaitInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var wineWhileYouWaitInfo, wwyw;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                wineWhileYouWaitInfo = this.joinWaitlistModel.wineWhileYouWaitInfo;

                if (wineWhileYouWaitInfo) {
                  _context6.next = 6;
                  break;
                }

                _context6.next = 4;
                return this.rootStore.platformUtil.getFromLocalStorage("WINE_WHILE_YOU_WAIT_INFO");

              case 4:
                wwyw = _context6.sent;
                if (wwyw) wineWhileYouWaitInfo = JSON.parse(wwyw);

              case 6:
                return _context6.abrupt("return", wineWhileYouWaitInfo);

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function loadWineWhileYouWaitInfo() {
        return _loadWineWhileYouWaitInfo.apply(this, arguments);
      }

      return loadWineWhileYouWaitInfo;
    }()
  }, {
    key: "resetAndClearLocalStorageWLValues",
    value: function () {
      var _resetAndClearLocalStorageWLValues = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _this$rootStore6, _this$rootStore6$plat;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return (_this$rootStore6 = this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : (_this$rootStore6$plat = _this$rootStore6.platformUtil) === null || _this$rootStore6$plat === void 0 ? void 0 : _this$rootStore6$plat.removeFromLocalStorage("hideEstimatedWaitTimeInJWC");

              case 2:
                this.joinWaitlistModel.waitListId = "";
                this.joinWaitlistModel.wineWhileYouWaitInfo = null;
                this.joinWaitlistModel.resetValues();
                _context7.next = 7;
                return this.rootStore.platformUtil.clearLocalStorage(["WAITLIST_ID", "WINE_WHILE_YOU_WAIT_INFO", "JOIN_WAITLIST_TIMESTAMP"]);

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function resetAndClearLocalStorageWLValues() {
        return _resetAndClearLocalStorageWLValues.apply(this, arguments);
      }

      return resetAndClearLocalStorageWLValues;
    }()
  }, {
    key: "getWaitlist",
    value: function () {
      var _getWaitlist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _this5 = this;

        var isFromCancelWaitlist,
            waitListId,
            wwyw,
            _this$rootStore7,
            _this$rootStore7$plat,
            _this$rootStore8,
            _this$rootStore8$plat,
            jwTimestamp,
            isJwTimestampPassed,
            _yield$handle,
            _yield$handle2,
            err,
            waitListResponse,
            _err$errors,
            _err$errors$,
            _err$errors2,
            _err$errors2$,
            _err$errors3,
            _err$errors3$,
            _waitListResponse$wai,
            _waitListResponse$wai2,
            _args8 = arguments;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                isFromCancelWaitlist = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : false;
                _context8.next = 3;
                return this.loadAndGetWaitlistId();

              case 3:
                waitListId = _context8.sent;
                _context8.next = 6;
                return this.loadWineWhileYouWaitInfo();

              case 6:
                wwyw = _context8.sent;

                if (!isFromCancelWaitlist) {
                  _context8.next = 16;
                  break;
                }

                _context8.next = 10;
                return (_this$rootStore7 = this.rootStore) === null || _this$rootStore7 === void 0 ? void 0 : (_this$rootStore7$plat = _this$rootStore7.platformUtil) === null || _this$rootStore7$plat === void 0 ? void 0 : _this$rootStore7$plat.removeFromLocalStorage("hideEstimatedWaitTimeInJWC");

              case 10:
                this.joinWaitlistModel.waitListId = "";
                this.joinWaitlistModel.wineWhileYouWaitInfo = null;
                this.joinWaitlistModel.resetValues();
                _context8.next = 15;
                return this.rootStore.platformUtil.clearLocalStorage(["WAITLIST_ID", "WINE_WHILE_YOU_WAIT_INFO", "JOIN_WAITLIST_TIMESTAMP"]);

              case 15:
                return _context8.abrupt("return");

              case 16:
                if (!waitListId) {
                  _context8.next = 46;
                  break;
                }

                _context8.t0 = parseInt;
                _context8.next = 20;
                return this === null || this === void 0 ? void 0 : (_this$rootStore8 = this.rootStore) === null || _this$rootStore8 === void 0 ? void 0 : (_this$rootStore8$plat = _this$rootStore8.platformUtil) === null || _this$rootStore8$plat === void 0 ? void 0 : _this$rootStore8$plat.getFromLocalStorage("JOIN_WAITLIST_TIMESTAMP");

              case 20:
                _context8.t1 = _context8.sent;
                jwTimestamp = (0, _context8.t0)(_context8.t1); // if current date is greater than the JW joined timestamp + 3hrs that means it is expired.

                isJwTimestampPassed = jwTimestamp + 3 * 60 * 60 * 1000 < Date.now();

                if (!isJwTimestampPassed) {
                  _context8.next = 27;
                  break;
                }

                _context8.next = 26;
                return this.resetAndClearLocalStorageWLValues();

              case 26:
                return _context8.abrupt("return");

              case 27:
                _context8.next = 29;
                return handle(DPServices.Waitlist.getWaitlistDetails({
                  waitListId: waitListId
                }));

              case 29:
                _yield$handle = _context8.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                err = _yield$handle2[0];
                waitListResponse = _yield$handle2[1];

                if (!(err || !waitListResponse)) {
                  _context8.next = 41;
                  break;
                }

                _context8.next = 36;
                return this.resetAndClearLocalStorageWLValues();

              case 36:
                if (!this.fromLocationSearch) {
                  _context8.next = 38;
                  break;
                }

                return _context8.abrupt("return");

              case 38:
                if (err instanceof DPServices.Errors.UIError) {
                  this.analyticsModel.dispatchWLErrorEvent(err === null || err === void 0 ? void 0 : (_err$errors = err.errors) === null || _err$errors === void 0 ? void 0 : (_err$errors$ = _err$errors[0]) === null || _err$errors$ === void 0 ? void 0 : _err$errors$.code, err === null || err === void 0 ? void 0 : (_err$errors2 = err.errors) === null || _err$errors2 === void 0 ? void 0 : (_err$errors2$ = _err$errors2[0]) === null || _err$errors2$ === void 0 ? void 0 : _err$errors2$.message);
                  this.rootStore.appMessages.showError(i18next.t("text.joinwaitlist.error_waitlist_expired", {
                    defaultValue: "Oops!"
                  }), err === null || err === void 0 ? void 0 : (_err$errors3 = err.errors) === null || _err$errors3 === void 0 ? void 0 : (_err$errors3$ = _err$errors3[0]) === null || _err$errors3$ === void 0 ? void 0 : _err$errors3$.message, null, {
                    okBtnText: "Re-Join Waitlist",
                    cancelBtnText: "Cancel",
                    okBtnOnClick: function okBtnOnClick() {
                      _this5.redirectToJoinWaitlist();
                    },
                    undismissible: true,
                    cancelBtnOnClick: function cancelBtnOnClick() {
                      var _this5$rootStore, _this5$rootStore$plat;

                      (_this5$rootStore = _this5.rootStore) === null || _this5$rootStore === void 0 ? void 0 : (_this5$rootStore$plat = _this5$rootStore.platformUtil) === null || _this5$rootStore$plat === void 0 ? void 0 : _this5$rootStore$plat.navigateToRoute("/home");
                    }
                  });
                }

                _context8.next = 46;
                break;

              case 41:
                this.joinWaitlistModel.waitListId = waitListId;
                this.joinWaitlistModel.wineWhileYouWaitInfo = wwyw;
                this.joinWaitlistModel.setWaitlistDetails(waitListResponse);
                this.analyticsModel.setRestaurantDetailData(waitListResponse === null || waitListResponse === void 0 ? void 0 : waitListResponse.restaurantDetail);
                this.analyticsModel.setWaitListData({
                  numberOfGuests: "".concat(waitListResponse === null || waitListResponse === void 0 ? void 0 : (_waitListResponse$wai = waitListResponse.waitListDetail) === null || _waitListResponse$wai === void 0 ? void 0 : _waitListResponse$wai.partySize),
                  waitTime: "".concat(waitListResponse === null || waitListResponse === void 0 ? void 0 : (_waitListResponse$wai2 = waitListResponse.waitListDetail) === null || _waitListResponse$wai2 === void 0 ? void 0 : _waitListResponse$wai2.exactWaitTime)
                });

              case 46:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getWaitlist() {
        return _getWaitlist.apply(this, arguments);
      }

      return getWaitlist;
    }()
  }, {
    key: "createWaitlist",
    value: function () {
      var _createWaitlist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this$joinWaitlistMod2, _this$joinWaitlistMod4, _this$joinWaitlistMod5, _this$_appAttributes, _this$_appAttributes$, _createWaitlistRespon, _this$joinWaitlistMod12, _this$joinWaitlistMod3, firstName, lastName, email, partySize, phoneNumber, eclubOptin, payload, signUpSource, createWaitlistResponse, _createWaitlistRespon2, _createWaitlistRespon3, _this$joinWaitlistMod6, _this$joinWaitlistMod7, _this$joinWaitlistMod8, _this$joinWaitlistMod9, _this$joinWaitlistMod10, _this$joinWaitlistMod11, _this$rootStore9, _this$rootStore9$plat, _createWaitlistRespon4, _this$joinWaitlistMod13, errorDescription, _err$errors4, _err$errors4$, _err$errors5, _err$errors5$, _err$errors6, _err$errors6$;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                (_this$joinWaitlistMod2 = this.joinWaitlistModel) === null || _this$joinWaitlistMod2 === void 0 ? void 0 : _this$joinWaitlistMod2.setIsCTALoading(true);
                _this$joinWaitlistMod3 = this.joinWaitlistModel, firstName = _this$joinWaitlistMod3.firstName, lastName = _this$joinWaitlistMod3.lastName, email = _this$joinWaitlistMod3.email, partySize = _this$joinWaitlistMod3.partySize, phoneNumber = _this$joinWaitlistMod3.phoneNumber, eclubOptin = _this$joinWaitlistMod3.eclubOptin;
                payload = {
                  firstName: firstName,
                  lastName: lastName,
                  email: email,
                  phoneNumber: phoneNumber,
                  partySize: partySize,
                  eclubOptin: eclubOptin,
                  restaurantNum: this === null || this === void 0 ? void 0 : (_this$joinWaitlistMod4 = this.joinWaitlistModel) === null || _this$joinWaitlistMod4 === void 0 ? void 0 : (_this$joinWaitlistMod5 = _this$joinWaitlistMod4.restaurantDetail) === null || _this$joinWaitlistMod5 === void 0 ? void 0 : _this$joinWaitlistMod5.restaurantNumber
                };
                signUpSource = (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.configs) === null || _this$_appAttributes$ === void 0 ? void 0 : _this$_appAttributes$.webAheadSignUpSource;
                _context9.next = 7;
                return DPServices.Waitlist.createWaitlistUser(_objectSpread(_objectSpread({}, payload), {}, {
                  signUpSource: signUpSource
                }));

              case 7:
                createWaitlistResponse = _context9.sent;

                if (createWaitlistResponse) {
                  _context9.next = 10;
                  break;
                }

                throw Errors.CREATE_WAITLIST;

              case 10:
                if (createWaitlistResponse) {
                  this.joinWaitlistModel.setWaitlistDetails(createWaitlistResponse);
                }

                if (!(createWaitlistResponse !== null && createWaitlistResponse !== void 0 && (_createWaitlistRespon = createWaitlistResponse.waitListDetail) !== null && _createWaitlistRespon !== void 0 && _createWaitlistRespon.visitId)) {
                  _context9.next = 22;
                  break;
                }

                this.joinWaitlistModel.visitId = createWaitlistResponse === null || createWaitlistResponse === void 0 ? void 0 : (_createWaitlistRespon2 = createWaitlistResponse.waitListDetail) === null || _createWaitlistRespon2 === void 0 ? void 0 : _createWaitlistRespon2.visitId;

                if (createWaitlistResponse !== null && createWaitlistResponse !== void 0 && (_createWaitlistRespon3 = createWaitlistResponse.waitListDetail) !== null && _createWaitlistRespon3 !== void 0 && _createWaitlistRespon3.waitListId) {
                  this.joinWaitlistModel.waitListId = createWaitlistResponse === null || createWaitlistResponse === void 0 ? void 0 : (_createWaitlistRespon4 = createWaitlistResponse.waitListDetail) === null || _createWaitlistRespon4 === void 0 ? void 0 : _createWaitlistRespon4.waitListId;
                }

                _context9.next = 16;
                return this.rootStore.platformUtil.saveInLocalStorage("VISIT_ID", JSON.stringify(this.joinWaitlistModel.visitId));

              case 16:
                _context9.next = 18;
                return this.rootStore.platformUtil.saveInLocalStorage("JOIN_WAITLIST_TIMESTAMP", JSON.stringify(Date.now()));

              case 18:
                this.storeWebaheadAndWWYWInfo(); //analytics when user joins waitlist

                this.analyticsModel.dispatchWaitlistComplete("".concat((_this$joinWaitlistMod6 = this.joinWaitlistModel) === null || _this$joinWaitlistMod6 === void 0 ? void 0 : (_this$joinWaitlistMod7 = _this$joinWaitlistMod6.estimatedWaitTime) === null || _this$joinWaitlistMod7 === void 0 ? void 0 : _this$joinWaitlistMod7.lowQuote, " - ").concat((_this$joinWaitlistMod8 = this.joinWaitlistModel) === null || _this$joinWaitlistMod8 === void 0 ? void 0 : (_this$joinWaitlistMod9 = _this$joinWaitlistMod8.estimatedWaitTime) === null || _this$joinWaitlistMod9 === void 0 ? void 0 : _this$joinWaitlistMod9.highQuote, " minutes"), partySize.toString(), this.joinWaitlistModel.waitListId, "".concat((_this$joinWaitlistMod10 = this.joinWaitlistModel) === null || _this$joinWaitlistMod10 === void 0 ? void 0 : (_this$joinWaitlistMod11 = _this$joinWaitlistMod10.restaurantDetail) === null || _this$joinWaitlistMod11 === void 0 ? void 0 : _this$joinWaitlistMod11.restaurantNumber));
                this.joinWaitlistModel.isEditWLConfirmation = false; // navigate to JW confirmation page for Web

                if (((_this$rootStore9 = this.rootStore) === null || _this$rootStore9 === void 0 ? void 0 : (_this$rootStore9$plat = _this$rootStore9.platformUtil) === null || _this$rootStore9$plat === void 0 ? void 0 : _this$rootStore9$plat.PLATFORM_TYPE) === PlatformType.WEB) {
                  this.redirectToWaitlistConfirmation();
                }

              case 22:
                (_this$joinWaitlistMod12 = this.joinWaitlistModel) === null || _this$joinWaitlistMod12 === void 0 ? void 0 : _this$joinWaitlistMod12.setIsCTALoading(false);
                _context9.next = 31;
                break;

              case 25:
                _context9.prev = 25;
                _context9.t0 = _context9["catch"](0);
                (_this$joinWaitlistMod13 = this.joinWaitlistModel) === null || _this$joinWaitlistMod13 === void 0 ? void 0 : _this$joinWaitlistMod13.setIsCTALoading(false);

                if (_context9.t0 instanceof DPServices.Errors.UIError) {
                  errorDescription = _context9.t0 === null || _context9.t0 === void 0 ? void 0 : (_err$errors4 = _context9.t0.errors) === null || _err$errors4 === void 0 ? void 0 : (_err$errors4$ = _err$errors4[0]) === null || _err$errors4$ === void 0 ? void 0 : _err$errors4$.message;
                  this.analyticsModel.dispatchWLErrorEvent(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : (_err$errors5 = _context9.t0.errors) === null || _err$errors5 === void 0 ? void 0 : (_err$errors5$ = _err$errors5[0]) === null || _err$errors5$ === void 0 ? void 0 : _err$errors5$.code, _context9.t0 === null || _context9.t0 === void 0 ? void 0 : (_err$errors6 = _context9.t0.errors) === null || _err$errors6 === void 0 ? void 0 : (_err$errors6$ = _err$errors6[0]) === null || _err$errors6$ === void 0 ? void 0 : _err$errors6$.message);
                } else {
                  errorDescription = Errors.CREATE_WAITLIST.message;
                }

                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, errorDescription);
                throw errorDescription;

              case 31:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 25]]);
      }));

      function createWaitlist() {
        return _createWaitlist.apply(this, arguments);
      }

      return createWaitlist;
    }()
  }, {
    key: "deleteWaitlist",
    value: function () {
      var _deleteWaitlist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var _this$rootStore10, _this$rootStore10$pla, restDetURL, waitListId, deleteWaitlistSuccess, _this$rootStore11, _this$rootStore11$pla, errorDescription, _err$errors7, _err$errors7$, _err$errors8, _err$errors8$, _err$errors9, _err$errors9$;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                restDetURL = this.restDetURL;
                _context10.next = 4;
                return (_this$rootStore10 = this.rootStore) === null || _this$rootStore10 === void 0 ? void 0 : (_this$rootStore10$pla = _this$rootStore10.platformUtil) === null || _this$rootStore10$pla === void 0 ? void 0 : _this$rootStore10$pla.removeFromLocalStorage("hideEstimatedWaitTimeInJWC");

              case 4:
                waitListId = this.joinWaitlistModel.waitListId;
                _context10.next = 7;
                return DPServices.Waitlist.deleteWaitlistDetails({
                  waitListId: waitListId
                });

              case 7:
                deleteWaitlistSuccess = _context10.sent;

                if (!deleteWaitlistSuccess) {
                  _context10.next = 18;
                  break;
                }

                this.joinWaitlistModel.waitListId = "";
                this.joinWaitlistModel.wineWhileYouWaitInfo = null;
                this.joinWaitlistModel.resetValues(); //analytics when user cancels waitlist

                (_this$rootStore11 = this.rootStore) === null || _this$rootStore11 === void 0 ? void 0 : (_this$rootStore11$pla = _this$rootStore11.platformUtil) === null || _this$rootStore11$pla === void 0 ? void 0 : _this$rootStore11$pla.dispatchEvent("AnalyticsEvent", "waitlistCancel", {});
                _context10.next = 15;
                return this.rootStore.platformUtil.clearLocalStorage(["WAITLIST_ID", "WINE_WHILE_YOU_WAIT_INFO", "JOIN_WAITLIST_TIMESTAMP"]);

              case 15:
                this.showCancelWaitlistSuccessMessage(restDetURL);
                _context10.next = 20;
                break;

              case 18:
                _context10.next = 20;
                return this.getWaitlist();

              case 20:
                _context10.next = 26;
                break;

              case 22:
                _context10.prev = 22;
                _context10.t0 = _context10["catch"](0);

                if (_context10.t0 instanceof DPServices.Errors.UIError) {
                  errorDescription = _context10.t0 === null || _context10.t0 === void 0 ? void 0 : (_err$errors7 = _context10.t0.errors) === null || _err$errors7 === void 0 ? void 0 : (_err$errors7$ = _err$errors7[0]) === null || _err$errors7$ === void 0 ? void 0 : _err$errors7$.message;
                  this.analyticsModel.dispatchWLErrorEvent(_context10.t0 === null || _context10.t0 === void 0 ? void 0 : (_err$errors8 = _context10.t0.errors) === null || _err$errors8 === void 0 ? void 0 : (_err$errors8$ = _err$errors8[0]) === null || _err$errors8$ === void 0 ? void 0 : _err$errors8$.code, _context10.t0 === null || _context10.t0 === void 0 ? void 0 : (_err$errors9 = _context10.t0.errors) === null || _err$errors9 === void 0 ? void 0 : (_err$errors9$ = _err$errors9[0]) === null || _err$errors9$ === void 0 ? void 0 : _err$errors9$.message);
                } else {
                  errorDescription = Errors.DELETE_WEBAHEAD.message;
                }

                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, errorDescription);

              case 26:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 22]]);
      }));

      function deleteWaitlist() {
        return _deleteWaitlist.apply(this, arguments);
      }

      return deleteWaitlist;
    }()
  }, {
    key: "restNumFromSession",
    value: function restNumFromSession() {
      var _this$_sessionDetails, _this$_sessionDetails2, _this$rootStore12, _this$rootStore12$use, _this$rootStore12$use2, _this$rootStore12$use3;

      return ((_this$_sessionDetails = this._sessionDetails) === null || _this$_sessionDetails === void 0 ? void 0 : (_this$_sessionDetails2 = _this$_sessionDetails.restaurantDetails) === null || _this$_sessionDetails2 === void 0 ? void 0 : _this$_sessionDetails2.restaurantNumber) || ((_this$rootStore12 = this.rootStore) === null || _this$rootStore12 === void 0 ? void 0 : (_this$rootStore12$use = _this$rootStore12.user) === null || _this$rootStore12$use === void 0 ? void 0 : (_this$rootStore12$use2 = _this$rootStore12$use.sessionDetails) === null || _this$rootStore12$use2 === void 0 ? void 0 : (_this$rootStore12$use3 = _this$rootStore12$use2.restaurantDetails) === null || _this$rootStore12$use3 === void 0 ? void 0 : _this$rootStore12$use3.restaurantNumber);
    }
  }, {
    key: "redirectToRestDetails",
    value: function () {
      var _redirectToRestDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _this$rootStore13, _this$rootStore13$pla;

        var restDetURL, _this$rootStore14, _this$rootStore14$pla, _this$rootStore15, _this$rootStore15$pla;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                restDetURL = this.restDetURL;

                if (((_this$rootStore13 = this.rootStore) === null || _this$rootStore13 === void 0 ? void 0 : (_this$rootStore13$pla = _this$rootStore13.platformUtil) === null || _this$rootStore13$pla === void 0 ? void 0 : _this$rootStore13$pla.PLATFORM_TYPE) === PlatformType.WEB) {
                  if (!!(restDetURL !== null && restDetURL !== void 0 && restDetURL.length)) {
                    (_this$rootStore14 = this.rootStore) === null || _this$rootStore14 === void 0 ? void 0 : (_this$rootStore14$pla = _this$rootStore14.platformUtil) === null || _this$rootStore14$pla === void 0 ? void 0 : _this$rootStore14$pla.redirectToURL(restDetURL);
                  } else {
                    (_this$rootStore15 = this.rootStore) === null || _this$rootStore15 === void 0 ? void 0 : (_this$rootStore15$pla = _this$rootStore15.platformUtil) === null || _this$rootStore15$pla === void 0 ? void 0 : _this$rootStore15$pla.redirectToURL("/menu");
                  }
                }

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function redirectToRestDetails() {
        return _redirectToRestDetails.apply(this, arguments);
      }

      return redirectToRestDetails;
    }()
  }, {
    key: "storeWebaheadAndWWYWInfo",
    value: function () {
      var _storeWebaheadAndWWYWInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _this$joinWaitlistMod14, _this$joinWaitlistMod15, _this$joinWaitlistMod16, _this$joinWaitlistMod17, _this$joinWaitlistMod20;

        var _this$joinWaitlistMod18, _this$joinWaitlistMod19;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(!((_this$joinWaitlistMod14 = this.joinWaitlistModel) !== null && _this$joinWaitlistMod14 !== void 0 && _this$joinWaitlistMod14.waitListTimeDetails) && (_this$joinWaitlistMod15 = this.joinWaitlistModel) !== null && _this$joinWaitlistMod15 !== void 0 && (_this$joinWaitlistMod16 = _this$joinWaitlistMod15.restaurantDetail) !== null && _this$joinWaitlistMod16 !== void 0 && (_this$joinWaitlistMod17 = _this$joinWaitlistMod16.promoInfo) !== null && _this$joinWaitlistMod17 !== void 0 && _this$joinWaitlistMod17.enableWebaheadPromo)) {
                  _context12.next = 3;
                  break;
                }

                _context12.next = 3;
                return this.getWaitTime((_this$joinWaitlistMod18 = this.joinWaitlistModel) === null || _this$joinWaitlistMod18 === void 0 ? void 0 : (_this$joinWaitlistMod19 = _this$joinWaitlistMod18.currentWaitlistRestNum) === null || _this$joinWaitlistMod19 === void 0 ? void 0 : _this$joinWaitlistMod19.toString());

              case 3:
                _context12.next = 5;
                return this.rootStore.platformUtil.saveInLocalStorage("ORDER_AHEAD_ENABLED", JSON.stringify(this.joinWaitlistModel.isOrderAheadEnabled));

              case 5:
                _context12.next = 7;
                return this.rootStore.platformUtil.saveInLocalStorage("WAITLIST_ID", this.joinWaitlistModel.waitListId);

              case 7:
                _context12.next = 9;
                return this.rootStore.platformUtil.saveInLocalStorage("WINE_WHILE_YOU_WAIT_INFO", JSON.stringify((_this$joinWaitlistMod20 = this.joinWaitlistModel.restaurantDetail) === null || _this$joinWaitlistMod20 === void 0 ? void 0 : _this$joinWaitlistMod20.promoInfo));

              case 9:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function storeWebaheadAndWWYWInfo() {
        return _storeWebaheadAndWWYWInfo.apply(this, arguments);
      }

      return storeWebaheadAndWWYWInfo;
    }() //TODO(WL) : if req otherwise remove

  }, {
    key: "getWaitTime",
    value: function () {
      var _getWaitTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(restaurantNum) {
        var waitTimeResponse, errorDescription, _err$errors10, _err$errors10$, _err$errors11, _err$errors11$, _err$errors12, _err$errors12$;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return DPServices.Waitlist.getWaitTime({
                  restaurantNum: restaurantNum
                });

              case 3:
                waitTimeResponse = _context13.sent;

                if (waitTimeResponse) {
                  _context13.next = 6;
                  break;
                }

                throw Errors.GET_WAIT_TIME;

              case 6:
                if (waitTimeResponse) {
                  this.joinWaitlistModel.restaurantDetail = waitTimeResponse === null || waitTimeResponse === void 0 ? void 0 : waitTimeResponse.restaurantDetail;
                }

                _context13.next = 13;
                break;

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13["catch"](0);

                if (_context13.t0 instanceof DPServices.Errors.UIError) {
                  errorDescription = _context13.t0 === null || _context13.t0 === void 0 ? void 0 : (_err$errors10 = _context13.t0.errors) === null || _err$errors10 === void 0 ? void 0 : (_err$errors10$ = _err$errors10[0]) === null || _err$errors10$ === void 0 ? void 0 : _err$errors10$.message;
                  this.analyticsModel.dispatchWLErrorEvent(_context13.t0 === null || _context13.t0 === void 0 ? void 0 : (_err$errors11 = _context13.t0.errors) === null || _err$errors11 === void 0 ? void 0 : (_err$errors11$ = _err$errors11[0]) === null || _err$errors11$ === void 0 ? void 0 : _err$errors11$.code, _context13.t0 === null || _context13.t0 === void 0 ? void 0 : (_err$errors12 = _context13.t0.errors) === null || _err$errors12 === void 0 ? void 0 : (_err$errors12$ = _err$errors12[0]) === null || _err$errors12$ === void 0 ? void 0 : _err$errors12$.message);
                } else {
                  errorDescription = Errors.GET_WAIT_TIME.message;
                }

                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, errorDescription);

              case 13:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 9]]);
      }));

      function getWaitTime(_x4) {
        return _getWaitTime.apply(this, arguments);
      }

      return getWaitTime;
    }()
  }, {
    key: "getEditWaitlistData",
    value: function () {
      var _getEditWaitlistData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var _this$joinWaitlistMod21, _this$joinWaitlistMod22, restNum, waitTimeResponse, _this$joinWaitlistMod23, errorDescription, _err$errors13, _err$errors13$, _err$errors14, _err$errors14$, _err$errors15, _err$errors15$;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                _context14.next = 3;
                return this.getWaitlist();

              case 3:
                restNum = (_this$joinWaitlistMod21 = this.joinWaitlistModel) === null || _this$joinWaitlistMod21 === void 0 ? void 0 : (_this$joinWaitlistMod22 = _this$joinWaitlistMod21.restaurantDetail) === null || _this$joinWaitlistMod22 === void 0 ? void 0 : _this$joinWaitlistMod22.restaurantNumber;

                if (restNum) {
                  _context14.next = 6;
                  break;
                }

                return _context14.abrupt("return");

              case 6:
                _context14.next = 8;
                return DPServices.Waitlist.getWaitTime({
                  restaurantNum: restNum === null || restNum === void 0 ? void 0 : restNum.toString()
                });

              case 8:
                waitTimeResponse = _context14.sent;

                if (waitTimeResponse) {
                  _context14.next = 11;
                  break;
                }

                throw Errors.GET_WAIT_TIME;

              case 11:
                if (!waitTimeResponse) {
                  _context14.next = 15;
                  break;
                }

                if ((_this$joinWaitlistMod23 = this.joinWaitlistModel) !== null && _this$joinWaitlistMod23 !== void 0 && _this$joinWaitlistMod23.restaurantDetail) {
                  _context14.next = 14;
                  break;
                }

                return _context14.abrupt("return");

              case 14:
                this.joinWaitlistModel.waitListTimeDetails = waitTimeResponse === null || waitTimeResponse === void 0 ? void 0 : waitTimeResponse.waitListTimeDetails;

              case 15:
                _context14.next = 21;
                break;

              case 17:
                _context14.prev = 17;
                _context14.t0 = _context14["catch"](0);

                if (_context14.t0 instanceof DPServices.Errors.UIError) {
                  errorDescription = _context14.t0 === null || _context14.t0 === void 0 ? void 0 : (_err$errors13 = _context14.t0.errors) === null || _err$errors13 === void 0 ? void 0 : (_err$errors13$ = _err$errors13[0]) === null || _err$errors13$ === void 0 ? void 0 : _err$errors13$.message;
                  this.analyticsModel.dispatchWLErrorEvent(_context14.t0 === null || _context14.t0 === void 0 ? void 0 : (_err$errors14 = _context14.t0.errors) === null || _err$errors14 === void 0 ? void 0 : (_err$errors14$ = _err$errors14[0]) === null || _err$errors14$ === void 0 ? void 0 : _err$errors14$.code, _context14.t0 === null || _context14.t0 === void 0 ? void 0 : (_err$errors15 = _context14.t0.errors) === null || _err$errors15 === void 0 ? void 0 : (_err$errors15$ = _err$errors15[0]) === null || _err$errors15$ === void 0 ? void 0 : _err$errors15$.message);
                } else {
                  errorDescription = Errors.GET_WAIT_TIME.message;
                }

                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, errorDescription);

              case 21:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 17]]);
      }));

      function getEditWaitlistData() {
        return _getEditWaitlistData.apply(this, arguments);
      }

      return getEditWaitlistData;
    }()
  }, {
    key: "hideWaitTimeOnConfPage",
    value: function () {
      var _hideWaitTimeOnConfPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var _this$_appAttributes2,
            _this$_appAttributes3,
            _this$rootStore16,
            _this$rootStore16$pla,
            _this6 = this;

        var waitListConfirmationReloadTimeInSeconds, hideEstimatedWaitTimeInJWCKey, _this$rootStore17, _this$rootStore17$pla, _moment, maxTime, currentTimeString, _moment2, _moment2$add, _this$rootStore18, _this$rootStore18$pla, _currentTimeString, _maxTime;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                waitListConfirmationReloadTimeInSeconds = +((_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : (_this$_appAttributes3 = _this$_appAttributes2.configs) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3.waitListConfirmationReloadTimeInSeconds) || 10;
                _context15.next = 3;
                return this === null || this === void 0 ? void 0 : (_this$rootStore16 = this.rootStore) === null || _this$rootStore16 === void 0 ? void 0 : (_this$rootStore16$pla = _this$rootStore16.platformUtil) === null || _this$rootStore16$pla === void 0 ? void 0 : _this$rootStore16$pla.getFromLocalStorage("hideEstimatedWaitTimeInJWC");

              case 3:
                hideEstimatedWaitTimeInJWCKey = _context15.sent;

                if (!hideEstimatedWaitTimeInJWCKey) {
                  _context15.next = 13;
                  break;
                }

                this._guestOnWaitlist = true;
                _context15.next = 8;
                return this === null || this === void 0 ? void 0 : (_this$rootStore17 = this.rootStore) === null || _this$rootStore17 === void 0 ? void 0 : (_this$rootStore17$pla = _this$rootStore17.platformUtil) === null || _this$rootStore17$pla === void 0 ? void 0 : _this$rootStore17$pla.getFromLocalStorage("hideEstimatedWaitTimeInJWC");

              case 8:
                maxTime = _context15.sent;
                currentTimeString = new Date();
                if ((_moment = moment(currentTimeString)) !== null && _moment !== void 0 && _moment.isSameOrAfter(maxTime)) this._hideWaitListInfoOnConfPage = true;
                _context15.next = 20;
                break;

              case 13:
                this._guestOnWaitlist = false;
                this._hideWaitListInfoOnConfPage = false;
                _currentTimeString = new Date();
                _maxTime = (_moment2 = moment(_currentTimeString)) === null || _moment2 === void 0 ? void 0 : (_moment2$add = _moment2.add(waitListConfirmationReloadTimeInSeconds, "seconds")) === null || _moment2$add === void 0 ? void 0 : _moment2$add.toString();
                _context15.next = 19;
                return this === null || this === void 0 ? void 0 : (_this$rootStore18 = this.rootStore) === null || _this$rootStore18 === void 0 ? void 0 : (_this$rootStore18$pla = _this$rootStore18.platformUtil) === null || _this$rootStore18$pla === void 0 ? void 0 : _this$rootStore18$pla.saveInLocalStorage("hideEstimatedWaitTimeInJWC", _maxTime);

              case 19:
                setTimeout(function () {
                  _this6._hideWaitListInfoOnConfPage = true;
                }, waitListConfirmationReloadTimeInSeconds * 1000);

              case 20:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function hideWaitTimeOnConfPage() {
        return _hideWaitTimeOnConfPage.apply(this, arguments);
      }

      return hideWaitTimeOnConfPage;
    }()
  }, {
    key: "editPartySize",
    value: function () {
      var _editPartySize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(partySize) {
        var _this$joinWaitlistMod24, waitListId, firstName, lastName, phoneNumber, email, payload, _this$joinWaitlistMod25, _this$joinWaitlistMod30, editWaitListResponse, _editWaitListResponse, _editWaitListResponse2, _this$joinWaitlistMod26, _this$joinWaitlistMod27, _this$joinWaitlistMod28, _this$joinWaitlistMod29, _this$joinWaitlistMod31, errorDescription, _err$errors16, _err$errors16$, _err$errors17, _err$errors17$, _err$errors18, _err$errors18$;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _this$joinWaitlistMod24 = this.joinWaitlistModel, waitListId = _this$joinWaitlistMod24.waitListId, firstName = _this$joinWaitlistMod24.firstName, lastName = _this$joinWaitlistMod24.lastName, phoneNumber = _this$joinWaitlistMod24.phoneNumber, email = _this$joinWaitlistMod24.email;
                payload = {
                  waitListId: waitListId,
                  partySize: partySize,
                  firstName: firstName,
                  lastName: lastName,
                  phoneNumber: phoneNumber,
                  email: email
                };
                _context16.prev = 2;
                (_this$joinWaitlistMod25 = this.joinWaitlistModel) === null || _this$joinWaitlistMod25 === void 0 ? void 0 : _this$joinWaitlistMod25.setIsCTALoading(true);
                _context16.next = 6;
                return DPServices.Waitlist.editWailist(payload);

              case 6:
                editWaitListResponse = _context16.sent;

                if (editWaitListResponse) {
                  _context16.next = 9;
                  break;
                }

                throw Errors.UPDATE_PARTY_SIZE;

              case 9:
                if (editWaitListResponse) {
                  this.joinWaitlistModel.partySize = editWaitListResponse === null || editWaitListResponse === void 0 ? void 0 : (_editWaitListResponse = editWaitListResponse.waitListDetail) === null || _editWaitListResponse === void 0 ? void 0 : _editWaitListResponse.partySize;
                  this.joinWaitlistModel.waitListPositionValue = editWaitListResponse === null || editWaitListResponse === void 0 ? void 0 : (_editWaitListResponse2 = editWaitListResponse.waitListDetail) === null || _editWaitListResponse2 === void 0 ? void 0 : _editWaitListResponse2.waitListPositionValue; //analytics when user edits party size

                  this.analyticsModel.dispatchWaitlistPartyUpdate("".concat((_this$joinWaitlistMod26 = this.joinWaitlistModel) === null || _this$joinWaitlistMod26 === void 0 ? void 0 : (_this$joinWaitlistMod27 = _this$joinWaitlistMod26.estimatedWaitTime) === null || _this$joinWaitlistMod27 === void 0 ? void 0 : _this$joinWaitlistMod27.lowQuote, " - ").concat((_this$joinWaitlistMod28 = this.joinWaitlistModel) === null || _this$joinWaitlistMod28 === void 0 ? void 0 : (_this$joinWaitlistMod29 = _this$joinWaitlistMod28.estimatedWaitTime) === null || _this$joinWaitlistMod29 === void 0 ? void 0 : _this$joinWaitlistMod29.highQuote, " minutes"), partySize.toString(), this.joinWaitlistModel.waitListId);
                  this.joinWaitlistModel.isEditWLConfirmation = true;
                }

                (_this$joinWaitlistMod30 = this.joinWaitlistModel) === null || _this$joinWaitlistMod30 === void 0 ? void 0 : _this$joinWaitlistMod30.setIsCTALoading(false);
                _context16.next = 18;
                break;

              case 13:
                _context16.prev = 13;
                _context16.t0 = _context16["catch"](2);
                (_this$joinWaitlistMod31 = this.joinWaitlistModel) === null || _this$joinWaitlistMod31 === void 0 ? void 0 : _this$joinWaitlistMod31.setIsCTALoading(false);

                if (_context16.t0 instanceof DPServices.Errors.UIError) {
                  errorDescription = _context16.t0 === null || _context16.t0 === void 0 ? void 0 : (_err$errors16 = _context16.t0.errors) === null || _err$errors16 === void 0 ? void 0 : (_err$errors16$ = _err$errors16[0]) === null || _err$errors16$ === void 0 ? void 0 : _err$errors16$.message;
                  this.analyticsModel.dispatchWLErrorEvent(_context16.t0 === null || _context16.t0 === void 0 ? void 0 : (_err$errors17 = _context16.t0.errors) === null || _err$errors17 === void 0 ? void 0 : (_err$errors17$ = _err$errors17[0]) === null || _err$errors17$ === void 0 ? void 0 : _err$errors17$.code, _context16.t0 === null || _context16.t0 === void 0 ? void 0 : (_err$errors18 = _context16.t0.errors) === null || _err$errors18 === void 0 ? void 0 : (_err$errors18$ = _err$errors18[0]) === null || _err$errors18$ === void 0 ? void 0 : _err$errors18$.message);
                } else {
                  errorDescription = DPServices.Common.checkAndGetErrorDescription(_context16.t0).message;
                }

                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, errorDescription);

              case 18:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[2, 13]]);
      }));

      function editPartySize(_x5) {
        return _editPartySize.apply(this, arguments);
      }

      return editPartySize;
    }()
  }, {
    key: "setUserInfoForWaitlistForm",
    value: function setUserInfoForWaitlistForm() {
      var _this$rootStore19, _this$rootStore19$use, _this$rootStore20, _this$rootStore20$use;

      var userProfile = (_this$rootStore19 = this.rootStore) === null || _this$rootStore19 === void 0 ? void 0 : (_this$rootStore19$use = _this$rootStore19.user) === null || _this$rootStore19$use === void 0 ? void 0 : _this$rootStore19$use.userProfile;
      var isUserLoggedIn = (_this$rootStore20 = this.rootStore) === null || _this$rootStore20 === void 0 ? void 0 : (_this$rootStore20$use = _this$rootStore20.user) === null || _this$rootStore20$use === void 0 ? void 0 : _this$rootStore20$use.isLoggedIn;

      if (isUserLoggedIn) {
        var _userProfile$defaultP;

        this.joinWaitlistModel.firstName = userProfile === null || userProfile === void 0 ? void 0 : userProfile.firstName;
        this.joinWaitlistModel.lastName = userProfile === null || userProfile === void 0 ? void 0 : userProfile.lastName;
        this.joinWaitlistModel.email = userProfile === null || userProfile === void 0 ? void 0 : userProfile.login;
        this.joinWaitlistModel.phoneNumber = formatPhoneNumber(userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$defaultP = userProfile.defaultPhone) === null || _userProfile$defaultP === void 0 ? void 0 : _userProfile$defaultP.phoneNumber);
      }
    }
  }, {
    key: "isJoinWaitListEnabled",
    value: function isJoinWaitListEnabled() {
      var _this$_appAttributes4;

      if ((_this$_appAttributes4 = this._appAttributes) !== null && _this$_appAttributes4 !== void 0 && _this$_appAttributes4.isWebaheadEnabled) {
        return true;
      }

      return false;
    }
  }, {
    key: "_getTimeOfDay",
    value: function _getTimeOfDay(currentMoment, hourStr) {
      var fullTimeStr = currentMoment.format("MM/DD/YYYY ") + hourStr;
      return moment(fullTimeStr, "MM/DD/YYYY h:mm A");
    }
  }, {
    key: "getJoinWaitListData",
    value: function () {
      var _getJoinWaitListData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var _this$restNumFromSess,
            _this7 = this;

        var restaurantNum, _this$rootStore21, _this$rootStore21$pla, locationPermissionsGranted, waitTimeResponse, _waitTimeResponse$res, oldRestaurantDetail, _waitTimeResponse$res2, _waitTimeResponse$res3, _this$rootStore22, _this$rootStore22$app, _waitTimeResponse$res4, errorDescription, _err$errors19, _err$errors19$, _err$errors20, _err$errors20$, _err$errors21, _err$errors21$;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                restaurantNum = (_this$restNumFromSess = this.restNumFromSession()) === null || _this$restNumFromSess === void 0 ? void 0 : _this$restNumFromSess.toString();

                if (restaurantNum) {
                  _context17.next = 4;
                  break;
                }

                if (((_this$rootStore21 = this.rootStore) === null || _this$rootStore21 === void 0 ? void 0 : (_this$rootStore21$pla = _this$rootStore21.platformUtil) === null || _this$rootStore21$pla === void 0 ? void 0 : _this$rootStore21$pla.PLATFORM_TYPE) === PlatformType.APP) {
                  locationPermissionsGranted = this.rootStore.user.foregroundLocationPermissionGranted;

                  if (!locationPermissionsGranted) {
                    this.rootStore.user.promptForLocationPermissions = true;
                  }
                } else {
                  this.rootStore.platformUtil.navigateToRoute("/locations/location-search");
                }

                return _context17.abrupt("return");

              case 4:
                _context17.prev = 4;
                _context17.next = 7;
                return DPServices.Waitlist.getWaitTime({
                  restaurantNum: restaurantNum
                });

              case 7:
                waitTimeResponse = _context17.sent;

                if (waitTimeResponse) {
                  _context17.next = 11;
                  break;
                }

                this._isWaitlistError = true;
                throw Errors.GET_WAIT_TIME;

              case 11:
                if (!waitTimeResponse) {
                  _context17.next = 24;
                  break;
                }

                oldRestaurantDetail = this.joinWaitlistModel.restaurantDetail;
                this.joinWaitlistModel.restaurantDetail = waitTimeResponse === null || waitTimeResponse === void 0 ? void 0 : waitTimeResponse.restaurantDetail;
                this.analyticsModel.setRestaurantDetailData(waitTimeResponse === null || waitTimeResponse === void 0 ? void 0 : waitTimeResponse.restaurantDetail);

                if (!(waitTimeResponse !== null && waitTimeResponse !== void 0 && (_waitTimeResponse$res = waitTimeResponse.restaurantDetail) !== null && _waitTimeResponse$res !== void 0 && _waitTimeResponse$res.waitlistEnabled)) {
                  _context17.next = 21;
                  break;
                }

                this.joinWaitlistModel.estimatedTime = waitTimeResponse === null || waitTimeResponse === void 0 ? void 0 : waitTimeResponse.estimatedTime;
                this.joinWaitlistModel.waitListTimeDetails = waitTimeResponse === null || waitTimeResponse === void 0 ? void 0 : waitTimeResponse.waitListTimeDetails;

                if (!this.joinWaitlistModel.partySize || oldRestaurantDetail.restaurantNumber !== waitTimeResponse.restaurantDetail.restaurantNumber) {
                  this.joinWaitlistModel.partySize = waitTimeResponse === null || waitTimeResponse === void 0 ? void 0 : (_waitTimeResponse$res2 = waitTimeResponse.restaurantDetail) === null || _waitTimeResponse$res2 === void 0 ? void 0 : (_waitTimeResponse$res3 = _waitTimeResponse$res2.partySizeInfo) === null || _waitTimeResponse$res3 === void 0 ? void 0 : _waitTimeResponse$res3.restDefaultPartySize;
                }

                _context17.next = 24;
                break;

              case 21:
                this._isWaitlistError = true;
                (_this$rootStore22 = this.rootStore) === null || _this$rootStore22 === void 0 ? void 0 : (_this$rootStore22$app = _this$rootStore22.appMessages) === null || _this$rootStore22$app === void 0 ? void 0 : _this$rootStore22$app.showError(i18next.t("waitlist.locationoff.title", {
                  defaultValue: "Waitlist Not Available"
                }), waitTimeResponse === null || waitTimeResponse === void 0 ? void 0 : (_waitTimeResponse$res4 = waitTimeResponse.restaurantDetail) === null || _waitTimeResponse$res4 === void 0 ? void 0 : _waitTimeResponse$res4.waitlistUnavailableMessage, null, {
                  undismissible: true,
                  okBtnText: i18next.t("text.joinwaitlist.rest.closed.error.okBtnText", {
                    defaultValue: "OK"
                  }),
                  okBtnOnClick: function okBtnOnClick() {
                    var _this7$rootStore, _this7$rootStore$plat;

                    (_this7$rootStore = _this7.rootStore) === null || _this7$rootStore === void 0 ? void 0 : (_this7$rootStore$plat = _this7$rootStore.platformUtil) === null || _this7$rootStore$plat === void 0 ? void 0 : _this7$rootStore$plat.navigateToRoute("/home");
                  }
                });
                return _context17.abrupt("return");

              case 24:
                _context17.next = 30;
                break;

              case 26:
                _context17.prev = 26;
                _context17.t0 = _context17["catch"](4);

                if (_context17.t0 instanceof DPServices.Errors.UIError) {
                  errorDescription = _context17.t0 === null || _context17.t0 === void 0 ? void 0 : (_err$errors19 = _context17.t0.errors) === null || _err$errors19 === void 0 ? void 0 : (_err$errors19$ = _err$errors19[0]) === null || _err$errors19$ === void 0 ? void 0 : _err$errors19$.message;
                  this.analyticsModel.dispatchWLErrorEvent(_context17.t0 === null || _context17.t0 === void 0 ? void 0 : (_err$errors20 = _context17.t0.errors) === null || _err$errors20 === void 0 ? void 0 : (_err$errors20$ = _err$errors20[0]) === null || _err$errors20$ === void 0 ? void 0 : _err$errors20$.code, _context17.t0 === null || _context17.t0 === void 0 ? void 0 : (_err$errors21 = _context17.t0.errors) === null || _err$errors21 === void 0 ? void 0 : (_err$errors21$ = _err$errors21[0]) === null || _err$errors21$ === void 0 ? void 0 : _err$errors21$.message);
                } else {
                  errorDescription = Errors.GET_WAIT_TIME.message;
                }

                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, errorDescription);

              case 30:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[4, 26]]);
      }));

      function getJoinWaitListData() {
        return _getJoinWaitListData.apply(this, arguments);
      }

      return getJoinWaitListData;
    }()
  }, {
    key: "redirectToJoinWaitlist",
    value: function redirectToJoinWaitlist() {
      var url = this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP ? "/JoinWaitlist" : "/wait-list";
      this.rootStore.platformUtil.navigateToRoute(url);
    }
  }, {
    key: "redirectToWaitlistConfirmation",
    value: function redirectToWaitlistConfirmation() {
      var _this$rootStore23, _this$rootStore23$pla, _this$rootStore24, _this$rootStore24$pla;

      var url = ((_this$rootStore23 = this.rootStore) === null || _this$rootStore23 === void 0 ? void 0 : (_this$rootStore23$pla = _this$rootStore23.platformUtil) === null || _this$rootStore23$pla === void 0 ? void 0 : _this$rootStore23$pla.PLATFORM_TYPE) === PlatformType.APP ? "/WaitlistDetails" : "/wait-list/confirmation";
      (_this$rootStore24 = this.rootStore) === null || _this$rootStore24 === void 0 ? void 0 : (_this$rootStore24$pla = _this$rootStore24.platformUtil) === null || _this$rootStore24$pla === void 0 ? void 0 : _this$rootStore24$pla.navigateToRoute(url);
    }
  }, {
    key: "showCancelWaitlistSuccessMessage",
    value: function showCancelWaitlistSuccessMessage() {
      var _this$rootStore25,
          _this$rootStore25$app,
          _this8 = this;

      var redirectionLink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      (_this$rootStore25 = this.rootStore) === null || _this$rootStore25 === void 0 ? void 0 : (_this$rootStore25$app = _this$rootStore25.appMessages) === null || _this$rootStore25$app === void 0 ? void 0 : _this$rootStore25$app.showError(i18next.t("text.rd.from_leave_waitlist_flow_header", {
        defaultValue: "Waitlist cancellation"
      }), i18next.t("text.rd.from_leave_waitlist_flow_body", {
        defaultValue: "You have been successfully removed from the waitlist."
      }), null, {
        undismissible: true,
        okBtnText: "OK",
        okBtnOnClick: function okBtnOnClick() {
          var _this8$rootStore, _this8$rootStore$plat, _this8$rootStore3, _this8$rootStore3$pla;

          if (((_this8$rootStore = _this8.rootStore) === null || _this8$rootStore === void 0 ? void 0 : (_this8$rootStore$plat = _this8$rootStore.platformUtil) === null || _this8$rootStore$plat === void 0 ? void 0 : _this8$rootStore$plat.PLATFORM_TYPE) === PlatformType.WEB && !!(redirectionLink !== null && redirectionLink !== void 0 && redirectionLink.length)) {
            var _this8$rootStore2, _this8$rootStore2$pla;

            (_this8$rootStore2 = _this8.rootStore) === null || _this8$rootStore2 === void 0 ? void 0 : (_this8$rootStore2$pla = _this8$rootStore2.platformUtil) === null || _this8$rootStore2$pla === void 0 ? void 0 : _this8$rootStore2$pla.redirectToURL(redirectionLink);
          } else (_this8$rootStore3 = _this8.rootStore) === null || _this8$rootStore3 === void 0 ? void 0 : (_this8$rootStore3$pla = _this8$rootStore3.platformUtil) === null || _this8$rootStore3$pla === void 0 ? void 0 : _this8$rootStore3$pla.redirectToURL("/home");
        }
      });
    }
  }, {
    key: "redirectToOrderWhileYouWait",
    value: function redirectToOrderWhileYouWait() {
      var _this$joinWaitlistMod32, _this$joinWaitlistMod33, _this$rootStore26, _this$rootStore26$pla;

      var url = "/menu/?orderType=dinein&restID=".concat(this === null || this === void 0 ? void 0 : (_this$joinWaitlistMod32 = this.joinWaitlistModel) === null || _this$joinWaitlistMod32 === void 0 ? void 0 : (_this$joinWaitlistMod33 = _this$joinWaitlistMod32.restaurantDetail) === null || _this$joinWaitlistMod33 === void 0 ? void 0 : _this$joinWaitlistMod33.atgRestaurantId);

      if (((_this$rootStore26 = this.rootStore) === null || _this$rootStore26 === void 0 ? void 0 : (_this$rootStore26$pla = _this$rootStore26.platformUtil) === null || _this$rootStore26$pla === void 0 ? void 0 : _this$rootStore26$pla.PLATFORM_TYPE) === PlatformType.WEB) {
        var _this$rootStore27, _this$rootStore27$pla;

        (_this$rootStore27 = this.rootStore) === null || _this$rootStore27 === void 0 ? void 0 : (_this$rootStore27$pla = _this$rootStore27.platformUtil) === null || _this$rootStore27$pla === void 0 ? void 0 : _this$rootStore27$pla.goToURL(url);
      }
    }
  }, {
    key: "_getPdfMenuUrl",
    value: function () {
      var _getPdfMenuUrl2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(restaurantNum) {
        var pdfMenu;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (this.joinWaitlistModel.showPDFMenu) {
                  _context18.next = 2;
                  break;
                }

                return _context18.abrupt("return");

              case 2:
                _context18.next = 4;
                return DPServices.Restaurant.getRestaurantPDFMenuURL(restaurantNum);

              case 4:
                pdfMenu = _context18.sent;
                this.joinWaitlistModel.pdfMenuUrl = pdfMenu;

              case 6:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function _getPdfMenuUrl(_x6) {
        return _getPdfMenuUrl2.apply(this, arguments);
      }

      return _getPdfMenuUrl;
    }()
  }, {
    key: "loadAndSetWaitlistId",
    value: function () {
      var _loadAndSetWaitlistId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var waitlistId, _this$rootStore28, _this$rootStore28$pla, jwTimestamp, isJwTimestampValid, wwyw;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.loadAndGetWaitlistId();

              case 2:
                waitlistId = _context19.sent;

                if (!waitlistId) {
                  _context19.next = 16;
                  break;
                }

                _context19.t0 = parseInt;
                _context19.next = 7;
                return this === null || this === void 0 ? void 0 : (_this$rootStore28 = this.rootStore) === null || _this$rootStore28 === void 0 ? void 0 : (_this$rootStore28$pla = _this$rootStore28.platformUtil) === null || _this$rootStore28$pla === void 0 ? void 0 : _this$rootStore28$pla.getFromLocalStorage("JOIN_WAITLIST_TIMESTAMP");

              case 7:
                _context19.t1 = _context19.sent;
                jwTimestamp = (0, _context19.t0)(_context19.t1); // Here we check if WL is valid. If current date is less than joining time + 3hrs, it is valid.

                isJwTimestampValid = jwTimestamp + 3 * 60 * 60 * 1000 > Date.now();

                if (!isJwTimestampValid) {
                  _context19.next = 16;
                  break;
                }

                this.joinWaitlistModel.waitListId = waitlistId;
                _context19.next = 14;
                return this.loadWineWhileYouWaitInfo();

              case 14:
                wwyw = _context19.sent;
                this.joinWaitlistModel.wineWhileYouWaitInfo = wwyw;

              case 16:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function loadAndSetWaitlistId() {
        return _loadAndSetWaitlistId.apply(this, arguments);
      }

      return loadAndSetWaitlistId;
    }()
  }, {
    key: "hideWaitListInfoOnConfPage",
    get: function get() {
      return this._hideWaitListInfoOnConfPage;
    }
  }, {
    key: "guestOnWaitlist",
    get: function get() {
      return this._guestOnWaitlist;
    }
  }, {
    key: "isWaitlistError",
    get: function get() {
      return this._isWaitlistError;
    }
  }, {
    key: "restDetURL",
    get: function get() {
      var _this$joinWaitlistMod34;

      var restDetURL = "";

      if (this !== null && this !== void 0 && (_this$joinWaitlistMod34 = this.joinWaitlistModel) !== null && _this$joinWaitlistMod34 !== void 0 && _this$joinWaitlistMod34.restaurantDetail) {
        var _this$joinWaitlistMod35, _this$joinWaitlistMod36, _this$joinWaitlistMod37, _this$joinWaitlistMod38, _this$joinWaitlistMod39, _this$joinWaitlistMod40, _this$joinWaitlistMod41, _this$joinWaitlistMod42, _this$joinWaitlistMod43, _this$joinWaitlistMod44, _this$joinWaitlistMod45, _this$joinWaitlistMod46;

        restDetURL = constructRestaurantDetailsUrl({
          state: this === null || this === void 0 ? void 0 : (_this$joinWaitlistMod35 = this.joinWaitlistModel) === null || _this$joinWaitlistMod35 === void 0 ? void 0 : (_this$joinWaitlistMod36 = _this$joinWaitlistMod35.restaurantDetail) === null || _this$joinWaitlistMod36 === void 0 ? void 0 : (_this$joinWaitlistMod37 = _this$joinWaitlistMod36.contactDetail) === null || _this$joinWaitlistMod37 === void 0 ? void 0 : (_this$joinWaitlistMod38 = _this$joinWaitlistMod37.address) === null || _this$joinWaitlistMod38 === void 0 ? void 0 : _this$joinWaitlistMod38.stateCode,
          city: this === null || this === void 0 ? void 0 : (_this$joinWaitlistMod39 = this.joinWaitlistModel) === null || _this$joinWaitlistMod39 === void 0 ? void 0 : (_this$joinWaitlistMod40 = _this$joinWaitlistMod39.restaurantDetail) === null || _this$joinWaitlistMod40 === void 0 ? void 0 : (_this$joinWaitlistMod41 = _this$joinWaitlistMod40.contactDetail) === null || _this$joinWaitlistMod41 === void 0 ? void 0 : (_this$joinWaitlistMod42 = _this$joinWaitlistMod41.address) === null || _this$joinWaitlistMod42 === void 0 ? void 0 : _this$joinWaitlistMod42.city,
          name: this === null || this === void 0 ? void 0 : (_this$joinWaitlistMod43 = this.joinWaitlistModel) === null || _this$joinWaitlistMod43 === void 0 ? void 0 : (_this$joinWaitlistMod44 = _this$joinWaitlistMod43.restaurantDetail) === null || _this$joinWaitlistMod44 === void 0 ? void 0 : _this$joinWaitlistMod44.restaurantName,
          id: this === null || this === void 0 ? void 0 : (_this$joinWaitlistMod45 = this.joinWaitlistModel) === null || _this$joinWaitlistMod45 === void 0 ? void 0 : (_this$joinWaitlistMod46 = _this$joinWaitlistMod45.restaurantDetail) === null || _this$joinWaitlistMod46 === void 0 ? void 0 : _this$joinWaitlistMod46.restaurantNumber
        });
      }

      return restDetURL;
    }
  }, {
    key: "customMapMarker",
    get: function get() {
      var _this$_appAttributes5, _this$_appAttributes6;

      return (_this$_appAttributes5 = this._appAttributes) === null || _this$_appAttributes5 === void 0 ? void 0 : (_this$_appAttributes6 = _this$_appAttributes5.configs) === null || _this$_appAttributes6 === void 0 ? void 0 : _this$_appAttributes6.mapMarkerUrl;
    }
  }, {
    key: "isQualityStoryEnabled",
    get: function get() {
      var _this$joinWaitlistMod47, _this$joinWaitlistMod48;

      return !(this !== null && this !== void 0 && (_this$joinWaitlistMod47 = this.joinWaitlistModel) !== null && _this$joinWaitlistMod47 !== void 0 && (_this$joinWaitlistMod48 = _this$joinWaitlistMod47.restaurantDetail) !== null && _this$joinWaitlistMod48 !== void 0 && _this$joinWaitlistMod48.disableQualityStore);
    }
  }, {
    key: "shouldDisableJoinWL",
    get: function get() {
      var _this$joinWaitlistMod49, _this$joinWaitlistMod51, _this$joinWaitlistMod52; // overrideNoWaitForWL should allow no waittime as valid entry


      var isNoWaitAllowed;

      if (this !== null && this !== void 0 && (_this$joinWaitlistMod49 = this.joinWaitlistModel) !== null && _this$joinWaitlistMod49 !== void 0 && _this$joinWaitlistMod49.isWaitlistNoWait) {
        var _this$joinWaitlistMod50;

        isNoWaitAllowed = !(this !== null && this !== void 0 && (_this$joinWaitlistMod50 = this.joinWaitlistModel) !== null && _this$joinWaitlistMod50 !== void 0 && _this$joinWaitlistMod50.overrideNoWaitForWL);
      } else {
        isNoWaitAllowed = false;
      }

      return this._isWaitlistError || (this === null || this === void 0 ? void 0 : (_this$joinWaitlistMod51 = this.joinWaitlistModel) === null || _this$joinWaitlistMod51 === void 0 ? void 0 : _this$joinWaitlistMod51.isWaitlistRestrictWait) || isNoWaitAllowed || (this === null || this === void 0 ? void 0 : (_this$joinWaitlistMod52 = this.joinWaitlistModel) === null || _this$joinWaitlistMod52 === void 0 ? void 0 : _this$joinWaitlistMod52.isWaitlistUnavailable);
    }
  }]);

  return JoinWaitlist;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_hideWaitListInfoOnConfPage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_guestOnWaitlist", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_isWaitlistError", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "hideWaitListInfoOnConfPage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideWaitListInfoOnConfPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "guestOnWaitlist", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "guestOnWaitlist"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isWaitlistError", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isWaitlistError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restDetURL", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restDetURL"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "customMapMarker", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "customMapMarker"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isQualityStoryEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isQualityStoryEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shouldDisableJoinWL", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "shouldDisableJoinWL"), _class.prototype)), _class);
export { JoinWaitlist as default };